module.exports = __webpack_public_path__ + "static/media/4.90b43f4d.png";